// @ts-nocheck
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useGetRelatedProductInfoFromList = convertSelectorToHook(getProductInfoFromList);
